export default __webpack_public_path__ + "static/media/28.e54f0e0a.jpg";